<template>
    <div>
        <v-row>
            <v-col cols="12">
                <editor ref="myEditor" :project-id="projectId" :tools="tools" style="height: 60vh;"
                    v-on:load="editorLoaded" v-on:ready="editorReady" />
            </v-col>
        </v-row>
    </div>
</template>
<script>

import { EmailEditor } from 'vue-email-editor';
import api from "@/api/layout";

export default {
    name: 'Editor',
    components: {
        editor: EmailEditor
    },
    props: {
        body: String | Object,
        updateBody: Function,
    },
    computed: {},
    data: function () {
        return {
            projectId: 273835,
            tools: {
                features: {
                    svgImageUpload: true,
                }
            },
            fields_replace: [
                { value: '0', header: "Indentificação", divider: true },
                { value: '{{nome}}', text: "Nome" },
                { value: '{{documento}}', text: "Documento" },
                { value: '{{nascimento}}', text: "Nascimento" },
                { value: '0', header: "Contato", divider: true },
                { value: '{{celular}}', text: "Celular" },
                { value: '{{telefone}}', text: "Telefone" },
                { value: '{{email}}', text: "Email" },
                { value: '{{email2}}', text: "Email Secundario" },
                { value: '0', header: "Endereço", divider: true },
                { value: '{{cep}}', text: "CEP" },
                { value: '{{endereco}}', text: "Endereço" },
                { value: '{{numero}}', text: "Número" },
                { value: '{{complemento}}', text: "Complemento" },
                { value: '{{bairro}}', text: "Bairro" },
                { value: '{{estado}}', text: "Estado" },
                { value: '{{cidade}}', text: "Cidade" },
            ],
            field_replace: '',
        }
    },
    watch: {
        'body': function (newValue, oldValue) {
            if (oldValue == '') {
                this.$refs.myEditor.editor.loadDesign({ ...newValue.content })
            }
        }
    },
    created() {
    },
    methods: {
        // called when the editor is created
        editorLoaded() { },
        // called when the editor has finished loading
        editorReady() {
            if (this.$refs.myEditor.editor) {

                const e = this.$refs.myEditor.editor;

                e.setMergeTags([
                    {
                        name: "Nome",
                        value: "{{nome}}"
                    },
                    {
                        name: "Documento",
                        value: "{{documento}}"
                    },
                    {
                        name: "Nascimento",
                        value: "{{nascimento}}"
                    },
                    {
                        name: "Celular",
                        value: "{{celular}}"
                    },
                    {
                        name: "Telefone",
                        value: "{{telefone}}"
                    },
                    {
                        name: "Email",
                        value: "{{email}}"
                    },
                    {
                        name: "Email Secundário",
                        value: "{{email2}}"
                    },
                    {
                        name: "CEP",
                        value: "{{cep}}"
                    },
                    {
                        name: "Endereço",
                        value: "{{endereco}}"
                    },
                    {
                        name: "Número",
                        value: "{{numero}}"
                    },
                    {
                        name: "Complemento",
                        value: "{{complemento}}"
                    },
                    {
                        name: "Bairro",
                        value: "{{bairro}}"
                    },
                    {
                        name: "Estado",
                        value: "{{estado}}"
                    },
                    {
                        name: "Cidade",
                        value: "{{cidade}}"
                    },
                ]);

                if (this.body) {
                    e.loadDesign({ ...this.body.content });
                }
                e.addEventListener('design:updated', () => {
                    e.saveDesign((design) => {
                        this.handleUpdateBody(design);
                    });
                });
            }
        },
        saveLayout() {
            this.saveDesign();
            this.exportHtml();
        },
        saveDesign() {
            console.log('saveDesign')
            this.$refs.myEditor.editor.saveDesign((design) => {
                console.log('saveDesign', design);
            });
        },
        exportHtml() {
            this.$refs.myEditor.editor.exportHtml((data) => {
                console.log('exportHtml', data);
            });
        },
        insertDataEditor() {
            if (!this.field_replace || this.field_replace === '0') return;

            const editor = this.$refs.myEditor.editor;

            console.log(editor); return;

            editor.editor.getSelectedBlock((block) => {
                if (block && block.type === 'text') {
                    const updatedText = block.values.text + ' ' + this.field_replace;

                    editor.editor.updateBlock(block.id, {
                        values: {
                            ...block.values,
                            text: updatedText,
                        }
                    });
                } else {
                    alert('Selecione um bloco de texto para inserir o campo.');
                }

                this.field_replace = '';
            });

        },
        handleUpdateBody(newBody) {
            this.$refs.myEditor.editor.saveDesign((design) => {
                this.updateBody({ ...this.body, content: design });
            });

            this.$refs.myEditor.editor.exportHtml((data) => {
                this.updateBody({ ...this.body, html: data });
            });


        }
    }
}
</script>

<style>
.ck-editor__editable {
    min-height: calc(100vh - 500px);
    max-height: calc(100vh - 450px);
}

.editorFull .ck-editor__editable {
    min-height: calc(100vh - 210px) !important;
    max-height: calc(100vh - 210px) !important;
}
</style>
